import {
    Component,
    OnInit,
  } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FormBuilder} from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
  import {MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { environment } from "src/environments/environment";

  

@Component({
    selector: "component-carica-verbale_wifi_fase3",
    templateUrl: "./dialog-carica_verbale_wifi_fase3.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogCaricaVerbaleWifiFase3 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected tipoDoc:String="";
    
    protected file: File;
    protected isUploadingDoc:boolean = false;
    
    protected label:string="Cerca il VERBALE WIFI" ;
    protected icona:string="";
    protected stile:string="btn-choose-file-preventivo";
    protected fileClass:string="btn-choose-file-preventivo";
    protected acceptedFileTypes:string=".pdf";
    protected displayFileName:string="";

    protected isFileUploaded: boolean = false;

    private collection_pratiche:string = environment.firebase.collection_pratiche;

    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      public firestore: AngularFirestore,
    ) {
      this.pratica          = this.config.data.pratica;
    
    }
  
    ngOnInit(): void {
    }

    onFileUpload($event){
    
      
    }

    onFileRemove($event: { files: File[]; }) {
      this.logger.info('Evento onFileRemove ricevuto:', $event);
      this.file = null;
      this.isFileUploaded = false;
      this.label = "Cerca il VERBALE WIFI";
      this.icona = "";
      this.fileClass = "btn-choose-file-preventivo";
    }

    onFileSelect($event: { files: File[]; }) {
      this.label = 'Verbale WIFI caricato';
        this.displayFileName = `Verbale WIFI - ${this.pratica.cui}`;
        this.icona = "pi pi-check";
        this.fileClass = "btn-preventivo-upload-success";
        this.file = $event.files[0];
        this.isFileUploaded = true;
    }  

   
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isUploadingDoc = true;
          const fileExtension = this.file.name.substring( this.file.name.lastIndexOf(".") + 1);
          const fileName = this.pratica.cui + "/IN/FASE_3/VERBALE_WIFI/VERBALE_WIFI_"+this.pratica.cui+".pdf";
           this.googleStorageService
            .uploadFileScuolaToGoogleStorage(this.file, fileName)
            .then((uploadRes) => {
              const docRef = this.firestore.collection(this.collection_pratiche).doc(this.pratica.cui);
              this.pratica.verbaleWifiUploaded = true;
            
              docRef.update(this.pratica)
                .then(() => {
                  /* .this.messageService.add({
                    severity: "info",
                    summary: "Successo" , life:10000,
                      detail: "Verbale wifi caricato con successo!",
                    }); */
                  this.isUploadingDoc = false;
                  this.dialogRef.close({ success: true});
                })
                .catch((error) => {
                  this.messageService.add({
                    severity: "info",
                    summary: "Errore" , life:10000,
                      detail: "Errore in fase di caricamento del verbale wifi!",
                    });
                  
                  this.dialogRef.close({ success: false });
                });
            })
            .catch((errore) => {
              this.messageService.add({
                severity: "info",
               summary: "Errore" , life:10000,
                detail: "Errore in fase di caricamento File!",
              });
    
              this.dialogRef.close({ success: false });
            });
        }
        

        
       
      
    }
  
  }